import ServiceCaller from "../../services/ServiceCaller";
import AdminService from "../../services/Admin";
const service = new AdminService()

// Load user information
const state = {
  error: "",
  deviceUpdateError: "",
  inProgress: false,
  status: null,
  devices: null,
  createResult: null,
  updateResult: null,
  customers: null,
  readSIMResponse: null,
  registrations: null,
  activationCodeBatches: null,
  activationCodes: null,
  hourStats: null,
  cache: null,
}
const mutations = {
  setError: (state, value) => {state.error = value},
  setDeviceUpdateError: (state, value) => {state.deviceUpdateError = value},
  setInProgress: (state, value) => {state.inProgress = value},
  setStatus: (state, value) => {state.status = value},
  setDevices: (state, value) => {state.devices = value},
  setCreateResult: (state, value) => {state.createResult = value},
  setUpdateResult: (state, value) => {state.updateResult = value},
  setCustomers: (state, value) => {state.customers = value},
  setReadSIMResponse: (state, value) => {state.readSIMResponse = value},
  setRegistrations: (state, value) => {state.registrations = value},
  setActivationCodeBatches: (state, value) => {state.activationCodeBatches = value},
  setActivationCodes: (state, value) => {state.activationCodes = value},
  setHourStats: (state, value) => {state.hourStats = value},
  setCacheResult: (state, value) => {state.cache = value},
}
const actions = {
  getStatus: (context) => ServiceCaller.call(service.getStatus(), context.commit, 'setStatus', 'setError', 'setInProgress', true),
  listDevices: (context) => ServiceCaller.call(service.listDevices(), context.commit, 'setDevices', 'setError', 'setInProgress', true),
  createDevices: (context, payload) => ServiceCaller.call(service.createDevices(payload), context.commit, 'setCreateResult', 'setError', 'setInProgress', true),

  resetDeviceOwnership: (context, payload) => ServiceCaller.call(service.resetDeviceOwnership(payload), context.commit, 'setUpdateResult', 'setDeviceUpdateError', 'setInProgress', true),
  setNonBillable: (context, payload) => ServiceCaller.call(service.setDeviceNonBillable(payload.deviceID, payload.value), context.commit, 'setUpdateResult', 'setDeviceUpdateError', 'setInProgress', true),
  shareDevice: (context, payload) => ServiceCaller.call(service.shareDevice(payload), context.commit, 'setUpdateResult', 'setDeviceUpdateError', 'setInProgress', true),
  sendSMS: (context, payload) => ServiceCaller.call(service.sendSMS(payload.deviceID, payload.messageText), context.commit, 'setUpdateResult', 'setDeviceUpdateError', 'setInProgress', true),

  listCustomers: (context) => ServiceCaller.call(service.listCustomers(), context.commit, 'setCustomers', 'setError', 'setInProgress', true),
  deleteCustomer: (context, payload) => ServiceCaller.call(service.deleteCustomer(payload), context.commit, 'setUpdateResult', 'setError', 'setInProgress', true),
  readSIM: (context, payload) => ServiceCaller.call(service.readSIM(payload.ICC, payload.SIMProvider), context.commit, 'setReadSIMResponse', 'setError', 'setInProgress', true),
  deleteDevice: (context, payload) => ServiceCaller.call(service.deleteDevice(payload), context.commit, 'setUpdateResult', 'setError', 'setInProgress', true),
  loadCache: (context) => ServiceCaller.call(service.loadCache(), context.commit, 'setCacheResult', 'setError', 'setInProgress', true),
  flushCache: (context, payload) => ServiceCaller.call(service.flushCache(payload), context.commit, 'setUpdateResult', 'setError', 'setInProgress', true),
  listRegistrations: (context) => ServiceCaller.call(service.listRegistrations(), context.commit, 'setRegistrations', 'setError', 'setInProgress', true),
  listActivationCodeBatches: (context) => ServiceCaller.call(service.listActivationCodeBatches(), context.commit, 'setActivationCodeBatches', 'setError', 'setInProgress', true),
  listActivationCodes: (context, payload) => ServiceCaller.call(service.listActivationCodes(payload), context.commit, 'setActivationCodes', 'setError', 'setInProgress', true),
  generateActivationCodeBatch: (context, payload) => ServiceCaller.call(service.generateActivationCodeBatch(payload.size, payload.name), context.commit, 'setUpdateResult', 'setError', 'setInProgress', true),
  downloadActivationCodeBatch: (context, payload) => ServiceCaller.call(service.downloadActivationCodeBatch(payload), context.commit, 'setUpdateResult', 'setError', 'setInProgress', true),
  exportDeviceInfluxes: (context, payload) => ServiceCaller.call(service.exportDeviceInfluxes(payload), context.commit, 'setUpdateResult', 'setError', 'setInProgress', true),
  exportGPX: (context, payload) => ServiceCaller.call(service.exportGPX(payload), context.commit, 'setUpdateResult', 'setError', 'setInProgress', true),

  hourStats: (context) => ServiceCaller.call(service.hourStats(), context.commit, 'setHourStats', 'setError', 'setInProgress', true),

}

const getters = {

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

